import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { logIn, fetch, fetchLocalAgent } from "../../actions";
import { ModalPadrao, LoadingContainerPadrao } from "../../components/Base";
import { useSave } from "../../components/Hooks/Conexao";
import BaixaSimples from "./BaixaSimples";
import { BtnGravar, BtnSair } from "../../components/Buttons";
import useTotaisBaixa from "../../components/Hooks/useTotaisBaixa";
import { formatarPagamentos } from "../../Utils/utils";
import { imprimirRetorno } from "../../Utils/impressaoUtils";

function ContasBaixa({ titulos, setTitulos, onOk, onCancel, visible, tipo, ...props }) {
    const [filtros, setFiltros] = useState({ tipo: titulos[0]?.tipo, periodicidade: "mensal", isParcial: false, juros: 0, desconto: 0 });
    const [baixar, isBaixando] = useSave(() => props.fetch().post("contas/baixar", { titulos, pagamentos: formatarPagamentos(pg, totais.troco), isParcial: false, tipo, ...filtros, ...totais }), ret => { onOk(); imprimirRetorno(props.fetchLocalAgent, ret); });
    const [pg, setPg] = useState([]);
    const totais = useTotaisBaixa(titulos, pg);

    useEffect(() => {
        if (visible)
            setPg([{ recebido: totais.liquido }]);

    }, [totais.liquido, visible]);

    return <ModalPadrao visible={visible} width={1000} title="Baixa de títulos" onCancel={onCancel}
        footer={<div style={{ display: "flex", justifyContent: "flex-end" }}>
            <BtnGravar disabled={pg.find(x => x.modalidadeId == null || x.modalidadeId <= 0)} txt="Baixar" onClick={baixar} loading={isBaixando} />
            <BtnSair onClick={onCancel} disabled={isBaixando} />
        </div>}>
        <LoadingContainerPadrao loading={isBaixando}>
            {!!titulos?.length && <BaixaSimples titulos={titulos} setTitulos={setTitulos} pg={pg} setPg={setPg} filtros={filtros} setFiltros={setFiltros} totais={totais} />}
        </LoadingContainerPadrao>
    </ModalPadrao>;
}
export default connect(null, { logIn, fetch, fetchLocalAgent })(ContasBaixa);